<template>
  <div class="dtlist">
    <!-- 头部 -->
    <hearderCommon :text="textT"></hearderCommon>
    <!-- 选择配送地址 -->
    <div class="dispatch">
      <van-cell is-link @click="showPopup">
        <div>
          <van-row gutter="20" class="orders-van-row" style="padding:0;padding-bottom:5px">
            <van-col span="8" class="orders-van-col">配送地址</van-col>
          </van-row>
          <van-row gutter="20" class="orders-van-row" style="padding:0">
            <van-col
              span="24"
              class="orders-van-col chose"
              v-show="showPrice"
            >{{DtList.deliveryName}}</van-col>
            <van-col span="24" class="orders-van-col chose" v-show="!showPrice">{{place}}</van-col>
          </van-row>
        </div>
        <!-- <div class="dispatch-price chose" v-show="!showPrice">{{place}}</div> -->
      </van-cell>
      <!-- 选择地址 -->
      <van-popup v-model="showPp" position="bottom" :style="{ height: '30%' }">
        <van-picker
          show-toolbar
          ref="picker"
          :columns="columns"
          @cancel="onCancel"
          @confirm="onConfirm"
          :default-index="0"
          @change="choseDId"
        />
      </van-popup>

      <div class="orders-time">
        <van-row gutter="20" class="orders-van-row oddr">
          <van-col span="8" class="orders-van-col">配送日期</van-col>
        </van-row>
        <van-cell is-link @click="showDataTime" v-show="!showTime" class="lateDay">{{lateDay}}</van-cell>

        <van-row gutter="20" class="orders-van-row clss" v-show="showTime">
          <van-col span="24" @click="others" class="DlateDay">{{ DtList.deliveryTime | dateFil}}</van-col>
        </van-row>
      </div>
    </div>

    <!-- 选择日期 -->
    <van-popup v-model="showData" position="bottom">
      <van-datetime-picker
        class="orders-datatime"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="timeCancel"
      />
    </van-popup>

    <!-- 订单号 -->
    <div class="ordersNum">订单{{DtList.orderCode}}</div>
    <!-- 订单列表 -->
    <div class="ordersList" style="position: relative; padding-bottom:90px;">
      <div class="goodList" v-for="index in DtList.children" :key="index.cartId">
        <div class="ty-top">
          <van-row>
            <van-col span="24" class="remDt_goodsName">
              <span @click="goDetails(index.goodsId)">{{index.goodsName}}</span>
            </van-col>
          </van-row>
          <van-row>
            <van-col
              span="17"
              class="remDt_left"
            >￥{{index.salePrice/index.saleRatio}}/{{index.saleUnitLabel}}</van-col>
            <van-col span="2" class="remDt_right">x{{index.orderQty}}{{index.saleUnitLabel}}</van-col>
            <van-col span="4" class="remDt_compile_div">
              <div class="remDt_compile van-hairline--left">
                <van-row>
                  <span
                    style="
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;"
                  >删除</span>
                </van-row>
                <van-row>
                  <span
                    style="
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(116,180,43,1);"
                    @click="compile"
                  >编辑</span>
                </van-row>
              </div>
            </van-col>
          </van-row>
          <!-- 编辑框 -->
          <van-dialog
            v-model="showCompile"
            confirmButtonColor="rgba(116, 180, 43, 1)"
            @confirm="confirmDialog"
            @cancel="cancelDialog"
            title="商品信息"
            show-cancel-button
          >
            <van-field v-model="name" label="商品名称" placeholder="请输入商品名称" />
            <van-field v-model="price" label="商品价格" placeholder="请输入商品价格" />
            <van-field v-model="unit" label="商品单位" placeholder="请输入商品单位" />
            <van-field v-model="numb" label="商品数量" placeholder="请输入商品数量" />
          </van-dialog>
          <div class="van-ellipsis">
            <van-row
              class="dt-diff"
              v-if="index.orderQty != (index.deliveryQty -index.diffQty)"
              type="flex"
              justify="space-between"
            >
              <van-col span="12">
                <span
                  class="lin-th"
                  v-if="index.actualPrice != index.confirmPrice"
                >¥{{index.actualPrice}}</span>
                <span class="lin-th-r">
                  ￥{{index.confirmPrice}}/{{index.saleUnitLabel}}
                  <span
                    v-if="index.saleRatio != 1 || index.goodsUnitLabel != index.saleUnitLabel"
                  >({{index.saleRatio}}{{index.goodsUnitLabel}})</span>
                </span>
              </van-col>
              <van-col span="8">
                <span class="dt-col-le">订/{{index.orderQty}}</span>
                <span class="dt-col-ri">收/{{index.deliveryQty-index.diffQty}}</span>
              </van-col>
            </van-row>
          </div>
          <!-- 备注 -->
          <!-- <div class="remark van-ellipsis" v-if="index.remark">备注：{{index.remark}}</div> -->
        </div>
      </div>
      <div class="add_dT_button">
        <van-button
          type="primary"
          size="normal"
          plain
          round
          color="#74B42B"
          @click="goCRDtList"
          class="add_dT_button_c"
        >
          <van-icon name="plus" class="plus" />新增商品
        </van-button>
      </div>
    </div>

    <van-submit-bar
      :price="totalPrice"
      button-text="提交订单"
      tip-icon="warning"
      tip="合计金额含服务费120元"
      safe-area-inset-bottom
      button-type="info round"
    >
      <div class="orders-submit-bar">共{{orderListLength}}件</div>
      <div class="div-btn">
        <van-button
          type="primary"
          size="small"
          class="send-btn btn-right"
          plain
          round
          @click="checking"
        >提交订单</van-button>
      </div>
    </van-submit-bar>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  props: ["orderId", "text"],
  created() {
    // 获取订单Id
    this.customerId = localStorage.getItem("customerId");
    // 获取客户Id
    this.customerId = localStorage.getItem("customerId");
    // 获取订单信息
    this.$axios.get(`/trade/tradeOrder/${this.orderId}`).then(res => {
      this.DtList = res.data.data;
      this.priceList = res.data.data.children;
      this.deliveryId = this.DtList.deliveryId;
      this.place = res.data.data.deliveryName;
      this.driverId = res.data.data.driverId;
      this.deliveryTime = new Date(res.data.data.deliveryTime);
      this.$emit("priceList", this.priceList);
    });
    // 获取配送信息
    this.$axios
      .get(`/customer/customerDelivery/customer/${this.customerId}`)
      .then(res => {
        this.priceList = res.data.data;
        res.data.data.forEach(item => {
          this.columns.push(item.name);
        });
      });
  },
  data() {
    return {
      DtList: {},
      textT: "修改补货订单",
      customerId: "", //用户ID
      showPp: false, //popup框显示
      columns: [], // 选择框列表
      priceList: [], //地址列表
      deliveryId: "", //地址ID
      showPrice: true, //显示已选地址
      place: "", //已选地址
      deliveryTime: "", //后台传输时间
      lateDay: "", //前端展示时间
      showTime: true, //显示时间
      currentDate: new Date(), //选择日期
      showData: false, //下弹出框
      minDate: new Date(), //选择最小时间
      maxDate: new Date(2022, 10, 1), //选择最大时间
      driverId: "", // 配送标签
      showCompile: false, //编辑模态框
      name: "", //商品名称
      price: "", //商品价格
      unit: "", //商品单位
      numb: "" //商品数量
    };
  },
  methods: {
    // 回退
    ListBack() {
      window.history.back();
    },
    // 确定对账
    checking() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "您确定要确认对账么？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          this.$axios
            .get(`/trade/tradeOrder/confirm/${this.orderId}`)
            .then(res => {
              if (res.data.code == 0) {
                this.$toast("对账成功");
                localStorage.setItem("orderId", this.orderId);
                this.$router.push("/Particular/particularSucceed");
              }
            });
        });
    },
    // 去商品详情页
    goDetails(goodsId) {
      this.$router.push({
        path: "/details",
        query: {
          goodsId: goodsId
        }
      });
    },
    // 选择地址选择
    showPopup() {
      this.showPp = true;
    },
    //点击取消
    onCancel() {
      this.showPp = false;
    },
    // 手动选择时间
    showDataTime() {
      this.showData = true;
    },
    // 修改时间样式
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    // 点击确认
    onConfirm(value) {
      this.place = value;
      this.showPp = false;
      this.showPrice = false;
    },
    // 时间按确认
    confirm(value) {
      this.deliveryTime = value;
      this.showTime = false;
      this.lateDay = this.$moment(value).format("YYYY-MM-DD");
      this.showData = false;
    },
    // 选择配送地址标签
    choseDId() {},
    // 配送时间选择
    deliveryTM(day) {
      // 往后台传输的数据
      this.deliveryTime = this.$moment()
        .add(+day, "day")
        .toDate();
      // 前台展示数据
      this.lateDay = this.$moment()
        .add(+day, "day")
        .format("YYYY-MM-DD");
      this.showTime = false;
    },
    // 其他时间
    others() {
      this.showData = true;
    },
    // 新增商品
    goCRDtList() {
      this.showCompile = true;
    },
    // 编辑
    compile() {
      this.showCompile = true;
    },
    // 模态框确认
    confirmDialog() {
      this.showCompile = false;
    },
    // 模态框取消
    cancelDialog() {
      this.showCompile = false;
    },
    timeCancel() {
      this.showData = false;
    }
  },
  computed: {
    // 合计价格
    totalPrice() {
      return this.priceList.reduce((price, item) => {
        price += item.totalPrice * 100;
        return price;
      }, 0);
    },
    // 总件数
    orderListLength() {
      return this.priceList.length;
    }
  },
  components: {
    hearderCommon
  }
};
</script>

<style scoped>
.height {
  height: 100%;
}
.dtlist {
  background: rgba(242, 242, 242, 1);
  padding-top: 32px;
}
.order-header-back {
  width: 80px;
}
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10009;
}

.van-cell:not(:last-child)::after {
  height: 10px;
  width: 90%;
}
.header {
  background: rgba(237, 237, 237, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 30px;
}
.i {
  position: absolute;
  top: 13px;
  left: 10px;
}
.dispatch {
  position: relative;
  margin: 18px auto 6px;
  width: 95%;
  background-color: #fff;
  border-radius: 8px !important;
}
.van-cell {
  background-color: transparent !important;
}
.van-cell--clickable {
  border-radius: 8px;
}
.van-cell__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 7px;
}
.van-cell__right-icon {
  position: absolute;
  top: 45%;
  right: 7%;
}
.van-cell__title {
  border-bottom: 1px dashed #999;
}
.orders-van-row {
  padding-left: 16px;
  padding-bottom: 10px;
}
.oddr {
  padding-bottom: 0px;
}
.orders-van-col {
  font-size: 12px;
  position: relative;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.ordersNum {
  padding-left: 3%;
  line-height: 32px;
  background: rgba(237, 237, 237, 1);
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
}
.ty-top {
  width: 90%;
  position: relative;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 2%;
  border-radius: 10px;
  padding: 10px;
  padding-left: 10px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.ty-center {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  background: rgba(237, 237, 237, 1);
  padding-left: 5%;
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
.remark {
  margin-top: 50px;
  width: 95%;
  margin: 0 auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  margin-left: 3%;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.van-submit-bar {
  background-color: rgba(237, 237, 237, 1);
}
.van-submit-bar__bar {
  padding-left: 3%;
}
.van-submit-bar__tip {
  padding: 2px 16px;
  background-color: rgba(245, 166, 35, 0.1);
}
.van-submit-bar__price {
  color: rgba(245, 166, 35, 1);
}
.orders-submit-bar {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.orders >>> .van-picker__confirm,
.orders >>> .van-picker__cancel {
  color: #74b42b !important;
}
.chose {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  font-size: 16px;
}
.lateDay >>> .van-cell__value,
.van-cell__value--alone {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.lateDay .van-cell__right-icon {
  top: 17%;
}
.lateDay {
  padding-top: 3px;
}
.bt-div {
  width: 100%;
  height: 30px;
}
.lin-th {
  text-decoration: line-through;
  font-size: 14px;
  margin-right: 4px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.lin-th-r {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 20px;
}
.dt-col-le {
  font-size: 12px;
  margin-right: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.dt-col-ri {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.van-submit-bar__button {
  display: none;
}
.van-submit-bar__text {
  margin-right: 40%;
}
.send-btn {
  float: right;
}
.btn-left {
  border: 1px solid #666;
  color: #666 !important;
}
.btn-right {
  right: 2%;
  border: 1px solid #74b42b;
  color: #74b42b !important;
}
.div-btn {
  position: absolute;
  right: 3%;
}
.change-btn {
  padding: 0 20px;
}
.van-icon-arrow-left {
  top: 11.5px;
}
.remDt_goodsName {
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  font-size: 14px;
}
.remDt_left {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 18px;
}
.remDt_right {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  /* text-align: right; */
}
.add_dT_button {
  margin-top: 6px;
  text-align: center;
}
.add_dT_button .van-button {
  line-height: 34px;
  width: 60%;
  height: 34px;
}
.plus {
  top: 2px;
}
.remDt_compile_div {
  position: relative;
}
.remDt_compile {
  height: 50px;
  width: 100%;
  position: absolute;
  top: -25px;
  left: 16px;
  line-height: 25px;
  text-align: center;
}
.DlateDay {
  color: #74b42b;
}
.lateDay .van-cell__right-icon[data-v-d24a7d6a] {
  top: 0;
}
.dtlist >>> .van-picker__confirm {
  color: #74b42b;
}
.dtlist >>> .van-picker__cancel {
  color: #000;
}
</style>